import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
const styles = {
    header: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '1px solid rgb(247, 247, 247);',
        boxShadow: 'rgb(255, 255, 255) 0px 1px 0px 0px inset',
    }),
};
export function Header(props) {
    return (_jsxs("div", { css: styles.header, children: [_jsx("div", { children: props.children[0] }), _jsx("div", { children: props.children[1] })] }));
}
//# sourceMappingURL=Header.js.map